module.exports = __webpack_public_path__ + "static/img/Bachelor_010690.021d0b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010690.jpg
// module id = 216
// module chunks = 0